import { Link } from 'react-router';
import { clsx } from 'clsx';
import { LEGAL_DOCS, type LegalDocKind } from './types';

type Props = {
  active: LegalDocKind;
};

export default function LegalTabsV2({ active }: Props) {
  return (
    <section className="border-y-[3px] border-charcoal-800 bg-charcoal-800">
      <div className="mx-auto max-w-7xl">
        <div className="flex overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {LEGAL_DOCS.map((doc, idx) => {
            const isActive = active === doc.kind;
            const num = String(idx + 1).padStart(2, '0');
            return (
              <Link
                key={doc.kind}
                to={doc.path}
                aria-current={isActive ? 'page' : undefined}
                className={clsx(
                  'flex min-w-[220px] flex-1 items-center gap-3.5 border-r border-charcoal-700 px-6 py-6 text-left font-marketing-display font-bold transition-colors duration-150',
                  'last:border-r-0',
                  isActive
                    ? 'bg-lime-500 text-charcoal-800'
                    : 'text-charcoal-200 hover:bg-charcoal-700 hover:text-white',
                )}
              >
                <span
                  className={clsx(
                    'flex h-8 w-8 shrink-0 items-center justify-center border-[1.5px] font-marketing-display text-[13px] font-bold',
                    isActive
                      ? 'border-charcoal-800 bg-charcoal-800 text-lime-500'
                      : 'border-charcoal-700 bg-charcoal-700 text-charcoal-200',
                  )}
                >
                  {num}
                </span>
                <span className="flex flex-col gap-0.5">
                  <span
                    className={clsx(
                      'font-marketing-mono text-[10px] font-medium uppercase tracking-[0.08em]',
                      isActive ? 'text-charcoal-800/70' : 'text-charcoal-400',
                    )}
                  >
                    {doc.kicker}
                  </span>
                  <span className="text-[16px]">{doc.short}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
